import { PageContainer } from 'components/PageContainer';
import { WorldFC } from 'components/World';

const TongQuanPage = (props) => {
  return (
    <PageContainer location={props.location}>
      <WorldFC />
    </PageContainer>
  );
};

export default TongQuanPage;
